import type unknown from '~/custom-pages/my-orders/children/unknown.vue'

import HighFrequency from '~/custom-pages/my-orders/children/high-frequency.vue'
import Scratchcards from '~/custom-pages/my-orders/children/scratchcards.vue'
import SingleOrders from '~/custom-pages/my-orders/children/single-orders.vue'
import Subscriptions from '~/custom-pages/my-orders/children/subscriptions.vue'

export type MyOrdersTabData = {
  comp:
    | typeof HighFrequency
    | typeof Scratchcards
    | typeof SingleOrders
    | typeof Subscriptions
    | typeof unknown
}

export const useMyOrders = async () => {
  const { t } = useNuxtApp().$i18n

  const isScratchcardsEnabled = useIsScratchcardEnabled()
  const isKenoEnabled = useRuntimeConfig().public.feature.keno

  const response = await useOrderedTypeLazyQuery({
    fetchPolicy: 'cache-first',
  }).load()

  const isScratchcardsTabActive = computed(
    () => isScratchcardsEnabled || !!orderedType.value?.scratchcard,
  )
  const isHighFrequencyTabActive = computed(
    () => isKenoEnabled || !!orderedType.value?.highFrequency,
  )
  const orderedType = computed(() => (response ? response.orderedType : null))

  const tabs = computed<TabInput<MyOrdersTabData>[]>(() => [
    {
      data: {
        comp: SingleOrders,
      },
      icon: 'orders',
      name: 'single-orders',
      title: t('myorders.tabs.singleorder.title'),
    },
    {
      data: {
        comp: Subscriptions,
      },
      icon: 'subscription',
      name: 'subscriptions',
      title: t('myorders.tabs.subscription.title'),
    },
    {
      active: isScratchcardsTabActive.value,
      data: {
        comp: Scratchcards,
      },
      icon: 'scratchcard',
      name: 'scratchcards',
      title: t('myorders.tabs.scratchcard.title'),
    },
    {
      active: isHighFrequencyTabActive.value,
      data: {
        comp: HighFrequency,
      },
      icon: 'keno',
      name: 'keno',
      title: t('myorders.tabs.highfrequency.title'),
    },
  ])

  const { activeTabs } = useTabs<MyOrdersTabData>(tabs)

  return { activeTabs }
}
